export default "__VITE_ASSET__r_d$SJph__"